import { styled } from '@mui/material/styles';

const InputGroup = styled('div')(() => ({
  margin: '1rem 0',
}));

export default InputGroup;
